import React, { Component } from "react";
import { Link } from "react-router-dom";

class AdminBreadcrumb extends Component {
  render() {
    return (
      <ul className="breadcrumb">
        {this.props.data.map((d, i) => {
          if (!d.link) {
            return (
              <li key={i} className="active">
                {d.name}
              </li>
            );
          } else {
            return (
              <li key={i}>
                <Link to={d.link}>{d.name}</Link>
              </li>
            );
          }
        })}
      </ul>
    );
  }
}

export default AdminBreadcrumb;



// WEBPACK FOOTER //
// ./src/containers/Admin/AdminMainContent/Common/Breadcrumb.js